import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { LanHealthComponent } from '@app/features/lan/modules/lan-health/lan-health.component';
import { DeviceModule } from '@app/features/device-health/device.module';
import { PosServicesCardComponent } from '@app/features/pos/components/pos-services-card/pos-services-card.component';
import { HealthNavComponent } from '@app/shared/components/health-nav/health-nav.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        DeviceModule,
        HealthNavComponent
    ],
    declarations: [
        LanHealthComponent,
        PosServicesCardComponent    
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class LanModule {}